module.exports = __webpack_public_path__ + "fonts/Cairo-Black.2594318e.ttf";